import angular from 'angular';

import APP_EVENTS from './constants/appEvents.constant';

import httpProviderConfig from './configs/httpProvider.config';

import AppAPI from './services/appAPI';
import AppAPIVersionInterceptor from './services/appAPIVersionInterceptor';
import AppErrorHandler from './services/appErrorHandler';
import AppEvents from './services/appEvents';
import AppUtils from './services/appUtils';
import locationUtils from './services/locationUtils';
import Passwords from './services/passwords';
import UIMessages from './services/uimessages';

import uimessagesContainer from './containers/uimessages.container';
import searchbox from './components/searchbox/searchbox.component';
import uimessages from './components/uimessages/uimessages.component';

import exceptionHandlerDecorator from './decorators/exceptionHandler.decorator';

import appOutdated from './eventsSubscribers/appOutdated';

/**
 * This is like a helper module with things the other modules may need.
 * @ngesdoc module
 * @ngname common
 */
const commonModule = angular.module('common', [])
.constant('APP_EVENTS', APP_EVENTS)
.config(httpProviderConfig)
.factory('locationUtils', locationUtils)
.service('appAPI', AppAPI)
.service('appAPIVersionInterceptor', AppAPIVersionInterceptor)
.service('appErrorHandler', AppErrorHandler)
.service('appEvents', AppEvents)
.service('appUtils', AppUtils)
.service('passwords', Passwords)
.service('uimessages', UIMessages)
.component('uimessagesContainer', uimessagesContainer)
.component('searchbox', searchbox)
.component('uimessages', uimessages)
.decorator('$exceptionHandler', exceptionHandlerDecorator)
.run(appOutdated);

export default commonModule.name;
